import { atom } from "nanostores";

import { Entity } from "../../api";

export const $isEntityCreationFormOpen = atom<boolean>(false);

export const $pastedMatchedEntities = atom<
  { entity: Entity; value: string }[] | null
>(null);
